import { LockKeyholeIcon } from 'lucide-react';

import { VowsAnalysisResponse } from '../../../../api/vowsAnalysis';
import Button from '../../../../components/v2/Button/Button';

const AnalyzeButton = ({
  handleClick,
  vowsAnalysis,
  hasAccess = false,
}: {
  handleClick: () => void;
  vowsAnalysis?: VowsAnalysisResponse;
  hasAccess: boolean;
}) => {
  return (
    <>
      <div className='flex flex-row justify-center items-center -my-2'>
        <div className='h-6 w-1 border-r border-forest-500'></div>
        <div></div>
      </div>
      <Button
        onClick={handleClick}
        variant={'secondary'}
        className={`px-12 self-center`}
        renderLeftIcon={() =>
          !hasAccess ? (
            <LockKeyholeIcon
              className={`text-forest-500 mr-2 invert-icon`}
            />
          ) : (
            <></>
          )
        }
      >
        {hasAccess && vowsAnalysis?.data?.vows_analysis ? 'View Analysis' : 'Analyze Vows'}
      </Button>
      <div className='flex flex-row justify-center items-center -my-2'>
        <div className='h-6 w-1 border-r border-forest-700'></div>
        <div></div>
      </div>
    </>
  );
};

export default AnalyzeButton;
